import { SET_AND_SHOW_CURRENCY } from '../actions/currencyMobileActions';

function relayVariableReducer(state = { showCurrency: false, currency: 'USD' }, action) {
    const { type } = action;

    switch (type) {
        case SET_AND_SHOW_CURRENCY:
            return { ...state, showCurrency: true, currency: action.currency };
        default:
            return state;
    }
}

export default relayVariableReducer;
